import type {
    CreatePubSubEventBaseParams,
    PubSubEventBase,
    PubSubEventType} from "@@/shared/pubsub-events/pubsub-event-base";
import {
    createPubSubEventBase
} from "@@/shared/pubsub-events/pubsub-event-base";
import type { PaymentPubSubEventData } from "./payment-pubsub-event-data";

type PaymentPubSubEventNamespace = "payment";
type PaymentPubSubEventBaseType<SpecificType extends string = string> =
    PubSubEventType<PaymentPubSubEventNamespace, SpecificType>;
type PaymentPubSubEventBase<
    SpecificType extends string = string,
    EventData extends Record<string, unknown> = Record<string, unknown>
> = PubSubEventBase<
    PaymentPubSubEventNamespace,
    SpecificType,
    PaymentPubSubEventData<EventData>
>;

const createPaymentPubSubEventBase = <
    SpecificType extends string = string,
    EventData extends Record<string, unknown> = Record<string, unknown>
>(
    params: CreatePubSubEventBaseParams<
        PaymentPubSubEventNamespace,
        SpecificType,
        PaymentPubSubEventData<EventData>
    >
) =>
    createPubSubEventBase<
        PaymentPubSubEventNamespace,
        SpecificType,
        PaymentPubSubEventData<EventData>
    >(params);

export type { PaymentPubSubEventBase, PaymentPubSubEventBaseType };
export { createPaymentPubSubEventBase };
